/**
 * Phone number helpers.
 *
 * Inputs accept ANY format — typed, pasted with parentheses/dashes/dots,
 * with or without a leading +1 — and render as (XXX) XXX-XXXX.
 */

/** Digits only, dropping a leading US country code. */
export const phoneDigits = (value) => {
  const digits = String(value ?? '').replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) return digits.slice(1);
  return digits.slice(0, 10);
};

/**
 * Format for display/entry: (XXX) XXX-XXXX, progressively as the user types.
 * Returns '' for empty input so placeholders still show.
 */
export const formatPhoneNumber = (value) => {
  const d = phoneDigits(value);
  if (d.length === 0) return '';
  if (d.length <= 3) return d;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6, 10)}`;
};

/** True when the value contains a complete 10-digit US number. */
export const isValidPhone = (value) => phoneDigits(value).length === 10;

/**
 * onChange helper: `onChange={handlePhoneChange((v) => setState(v))}`
 * Passes the formatted value to the setter.
 */
export const handlePhoneChange = (setter) => (event) => {
  setter(formatPhoneNumber(event.target.value));
};
